import React from "react"
import { Link, graphql } from "gatsby"
import SEO from "../components/seo"
import { ContactUsButton } from "../components/ContactModal"
import moment from "moment"
import Helmet from "react-helmet"
import styled from 'styled-components'

import { cgblue } from "../components/colors"
import Layout from "../components/Layout"
import kebabCase from "lodash/kebabCase"

const Template = ({
  data: {
    markdownRemark: {
      html,
      excerpt,
      frontmatter: { title, coverImage, coverImageList, tags, slug, author, date, focalPoint },
    },
  },
  pageContext: { prev, next },
}) => {
  coverImage = coverImage
    ? coverImage
    : "https://res.cloudinary.com/controlgap/image/upload/w_700,q_auto,f_auto/blog-images/controlgap-wall.jpg"

  coverImageList = coverImageList
    ? coverImageList
    : coverImage


  focalPoint = focalPoint ? `bg-align--${focalPoint}` : ""

  const StyledBanner = styled.div`
    background-color: cgblue;
    background-image: url(${coverImageList});
    height: 50vh;

    @media(min-width: 768px) {
      background-image: url(${coverImage});
    }
  `

  return (
    <Layout>
      <Helmet
        title={title}
        titleTemplate={`%s | ${title}`}
        meta={[
          {
            property: `og:title`,
            content: title,
          },
          {
            property: `og:image`,
            content: coverImage,
          },
          {
            property: `og:description`,
            content: slug + title,
          },
          {
            property: `og:url`,
            content: `https://www.controlgap.com/${slug}`,
          },
        ]}
      />
      <SEO title={`${title} | ${tags}`} />
      <div className="blog-post" id="nunito">
        <StyledBanner
          className={`hero hero-text-center ${focalPoint}`}
        >
          <div style={{ background: "rgba(0,0,0,0.3)" }}>
            <div className="container">
              <div style={{ width: "90%", maxWidth: "1000px", margin: "auto" }}>
                <h2
                  style={{ width: "90%", maxWidth: "700px", textAlign: "left" }}
                >
                  {title}
                </h2>
                <h4 style={{ fontWeight: "normal", textAlign: "left" }}>
                  {author && `By ${author} - `} 
                  {moment(date).format("DD MMM YYYY.")}
                </h4>
              </div>
            </div>
          </div>
        </StyledBanner>

        <div className="container">
          {tags.length >= 1 && (
            <ul className="tags">
              <span>Tags: </span>
              {tags.map(tag => (
                <li key={tag}>
                  <Link to={`/tags/${kebabCase(tag)}/`}>{tag}</Link>
                </li>
              ))}
              <li style={{ float: "right" }}>
                <a
                  href={`https://www.linkedin.com/shareArticle?mini=true&url=https://controlgap.com/blog/${encodeURIComponent(
                    slug
                  )}&title=${encodeURIComponent(title)}&source=controlgap.com`}
                >
                  <i
                    className="control-gap"
                    style={{ fontSize: "30px", float: "right" }}
                  >
                    x
                  </i>
                </a>
              </li>
            </ul>
          )}

          <div className="blog-body">
            <div dangerouslySetInnerHTML={{ __html: html }} />
          </div>
        </div>
        <div className="container">
          <div
            style={{
              width: "90%",
              maxWidth: "1000px",
              margin: "auto",
              display: "flex",
              justifyContent: "space-between",
              padding: "50px 0",
              borderTop: "1px solid",
              marginTop: 50,
            }}
          >
            {next && (
              <div className="blog-buttons" style={{ textAlign: "left" }}>
                <Link to={`blog/${next.frontmatter.slug}`}>
                  <span>
                    <i>previous</i>
                  </span>
                  <h4 style={{ marginTop: "0" }}>{next.frontmatter.title}</h4>
                </Link>
              </div>
            )}
            {prev ? (
              <div className="blog-buttons" style={{ textAlign: "right" }}>
                <Link to={`blog/${prev.frontmatter.slug}`}>
                  <span>
                    <i>next</i>
                  </span>
                  <h4 style={{ marginTop: "0" }}>{prev.frontmatter.title}</h4>
                </Link>
              </div>
            ) : (
              <div />
            )}
          </div>
        </div>
      </div>
      <section
        className="blog-footer"
        style={{ background: "#f6f6f6", padding: "50px" }}
      >
        <div className="container">
          <p>
            <strong>Cybersecurity can be difficult</strong>, why not let Control
            Gap guide you. We are the largest dedicated PCI compliance company
            in Canada.
            <br />
            <ContactUsButton text="Contact us" className="basic-button" /> today
            and learn more about how we can help you: Get Compliant. Stay
            Compliant.
          </p>{" "}
          <ContactUsButton text="Contact Us" />
        </div>
      </section>
    </Layout>
  )
}

export default Template

export const query = graphql`
  query($slug: String!) {
    markdownRemark(frontmatter: { slug: { eq: $slug } }) {
      html
      excerpt
      frontmatter {
        coverImage
        coverImageList
        focalPoint
        title
        date
        slug
        tags
        author
      }
    }
  }
`
//path: { eq: $path } })  takes path value from MD files
